import styled, {createGlobalStyle, css} from 'styled-components'

export const GlobalStyle = createGlobalStyle`
@keyframes glow {
  0% {
    box-shadow: var(--clr-shadow) 0 0 0;
  }
  100% {
    box-shadow: var(--clr-shadow) 0 1rem 4rem;
  }
}
  :root {
    border: none;
    box-shadow: none;

    --clr-shadow: hsl(43,86%,69%, 0.8);

    --clr-neon: #f25b4f;
    --clr-bright: #3066BE;
    --clr-light: #A4C3B2;
    --clr-medium: #656839;
    --clr-muted: #B79492;

    --clr-text: #fefcfb;
    --clr-text-H: 30;
    --clr-text-S: 50%;
    --clr-text-L: 99%;
}

  @media (max-width: 56rem) {
    body {
      font-size: 13px;
  }}
  @media (max-width: 43rem) {
    body {
      font-size: 10px;
    }
  }

  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    color: hsl(var(--clr-text-H), var(--clr-text-S), var(--clr-text-L));
    background: var(--clr-neon);

    font-family: 'Noto Sans Display', sans-serif;
    font-weight: 400;

    height: 100vh;
    width: 100vw;

    margin: 0;
    padding: 0;

    overflow: hidden;

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;

    box-sizing: border-box;

  }
  /* @media (max-width: 43rem) {
    body {
    font-size: 0.8rem;
  }
    } */
`

export const Marginals = css`
  position: fixed;
  z-index: 1;
  display: flex;
  width: 100vw;
  z-index: 1;

  pointer-events: none;
`
export const AbsoluteCenter = css`
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
`
export const P = styled.p`
  font-size: 1rem;
  margin: 1.2em 0;
  color: ${(props) => props.bgColor};

  &:nth-of-type(2) {
    margin-left: 1.5em;
  }
`
export const H3 = styled.h3`
  font-size: 4rem;
  font-weight: 600;
  line-height: 0.9;
  margin: 0.2em 0;
  color: ${(props) => props.bgColor};
`
export const H4 = styled.h4`
  font-size: 3rem;
  font-weight: 600;
  line-height: 1;
  margin: 0.6em 0 0;
  color: ${(props) => props.bgColor};
`

export const ImgCont = styled.div.attrs(({$isTogether}) => ({
  style: {
    animation: $isTogether ? 'glow 3s infinite alternate' : 'none'
  }
}))`
  position: relative;

  display: flex;
  flex-wrap: wrap;

  height: 80vmin;
  width: 60vmin;
`
export const Wrapper = styled.section.attrs(({$color}) => ({
  style: {
    backgroundColor: $color
  }
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`
export const NewsletterButton = styled.button`
  color: ${(props) => props.$textColor};
  border: 0.1em solid ${(props) => props.$textColor};
  position: absolute;
  right: -5vw;
  top: 10vh;

  background: none;

  border-radius: 100%;

  line-height: 1;
  font-size: 2rem;
  text-transform: uppercase;

  padding: 1em 0 0.9em;

  width: 8em;
  z-index: 1;

  cursor: pointer;

  &:hover {
    color: ${(props) => props.$bgColor};
    background: ${(props) => props.$textColor};
  }
`
export const TicketsButton = styled(NewsletterButton)`
  left: -8vw;
  top: 30vh;
`
